import styles from "src/components/elements/ModalSheetListItem/modalSheetListItem.module.css";

interface ModalSheetListItemProps {
    text: string;
    onClick: () => void;
    icon?: React.ReactNode;
    divider?: boolean;
    warning?: boolean;
}

const ModalSheetListItem: React.FC<ModalSheetListItemProps> = (props) => {
    return (
        <>
            <div
                className={styles.container}
                onClick={props.onClick}
                onKeyDown={props.onClick}
                role="button"
                tabIndex={0}
            >
                {props.icon && (
                    <div
                        className={`${styles.icon_container} ${
                            props.warning ? styles.warning : ""
                        }`}
                    >
                        {props.icon}
                    </div>
                )}
                <p className={props.warning ? styles.warning : ""}>
                    {props.text}
                </p>
            </div>
            {props.divider && <div className={styles.divider} />}
        </>
    );
};

export default ModalSheetListItem;
